import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'; // Importa Provider desde react-redux
import store from './Redux/store'; // Importa tu store Redux
import App from './App';

const root = createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
